export default __webpack_public_path__ + "static/media/pipe.b3ed48f9.png";